import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import ArgosVocab from './vocabs/argos';
import HabitatVocab from './vocabs/habitat';
import TuVocab from './vocabs/tu';
import SainsburysVocab from './vocabs/sainsburys';
var VocabContext = /*#__PURE__*/React.createContext();

function VocabProvider(_ref) {
  var children = _ref.children,
      vocab = _ref.vocab;
  if (!children) return null;
  return /*#__PURE__*/React.createElement(VocabContext.Provider, {
    value: vocab
  }, children);
}

function useVocab() {
  var context = React.useContext(VocabContext);

  if (context === undefined) {
    throw new Error('useVocab must be used within a VocabProvider');
  }

  return context;
}

function VocabConsumer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(VocabContext.Consumer, null, function (vocab) {
    if (vocab === undefined) {
      throw new Error('VocabConsumer must be used within a VocabProvider');
    }

    return React.Children.map(children, function (child) {
      return /*#__PURE__*/React.cloneElement(child, _objectSpread({}, vocab));
    });
  });
}

export { VocabProvider, VocabContext, useVocab, ArgosVocab, HabitatVocab, TuVocab, SainsburysVocab, VocabConsumer };